import { Component, Input, OnChanges } from '@angular/core';

import { ShareCopyStatus } from '../share/share.actions';
/* tslint:disable */
@Component({
  selector: 'nns-save-button',
  template: `
    <div class="nns-save-button-layout"
      flex layout="row" layout-align="start center"
      [ngClass]="getStateClass()"
    >
      <div class="nns-save-button-icon nns-save-button-icon__desktop">
        <nns-icon *ngIf="numericStatus===1" icon="plus"></nns-icon>
        <nns-icon *ngIf="numericStatus===2" icon="sync"></nns-icon>
        <nns-icon *ngIf="numericStatus===3" icon="check"></nns-icon>
      </div>
      <div class="nns-save-button-icon nns-save-button-icon__mobile">
        <nns-icon *ngIf="numericStatus===1" icon="plus-contrast"></nns-icon>
        <nns-icon *ngIf="numericStatus===2" icon="sync-contrast"></nns-icon>
        <nns-icon *ngIf="numericStatus===3" icon="check-contrast"></nns-icon>
      </div>

      <div class="nns-save-button-text" *ngIf="numericStatus===1">
        Save to FuseBase
      </div>
      <div class="nns-save-button-text" *ngIf="numericStatus===2">
        <span *ngIf="type === 'note'">
          The page is being saved now...
        </span>
        <span *ngIf="type === 'folder'">
          The folder is being saved now...
        </span>
      </div>
      <div class="nns-save-button-text" *ngIf="numericStatus===3">
        Saved, open in FuseBase
      </div>
    </div>
  `,
  styles: [`
    :host {
      display:block;
      cursor: pointer;
    }

    :host(.disabled) .nns-save-button-layout{
      background: #aeb7b8;
      cursor: default;
    }

    .nns-save-button-layout {
      background: #00A1B7;
      border-radius: 30px;
      color: #fff;
      display: flex;
      align-items: center;
      padding: 9px 14px;
      font-size: 13px;
    }

    .nns-save-button-icon{
      margin-right: 9px;
    }

    .nns-save-button-icon nns-icon{
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }

    .nns-save-button-icon__mobile {
      display: none;
    }

    /*states*/
    .nns-save-button-layout.saving {cursor: auto;}
    .nns-save-button-layout.saving .nns-save-button-icon {
      animation:rotation linear 1s infinite;
      -webkit-animation:rotation linear 1s infinite;
    }
    .nns-save-button-layout.saved {cursor: pointer;}

    @keyframes rotation {
        0% {transform:rotate(0deg);}
        100% {transform:rotate(360deg);}
    }
    @-webkit-keyframes rotation {
        0% {transform:rotate(0deg);}
        100% {transform:rotate(360deg);}
    }

    /*query*/
    @media only screen and (max-width: 768px) {
      .nns-save-button-text{
        display: none;
      }
      .nns-save-button-layout{
        background: transparent;
        padding: 0;
      }
      .nns-save-button-icon{
        margin: 0;
      }
      .nns-save-button-icon__desktop{
        display: none;
      }
      .nns-save-button-icon__mobile{
        display: block;
      }
    }
    @media only screen and (max-width: 600px) {

    }
  `,
  `
    :host-context(.nns-theme-night).disabled .nns-save-button-layout {
      background: #20252B;
    }
  `]
})
export class SaveButtonComponent implements OnChanges {
  @Input() state;
  @Input() showTitle;
  @Input() type;
  title;
  numericStatus: number;

  ngOnChanges() {
    this.title = this.getSaveCopyTitle();
    this.numericStatus = this.getSaveCopyNumericStatus();
  }

  getSaveCopyTitle() {
    if (this.state === ShareCopyStatus.SHARE_COPY_IN_PROGRESS) {
      return "Saving";
    }
    if (this.state === ShareCopyStatus.SHARE_COPY_DONE) {
      return "Saved!";
    }
    return "Save to FuseBase";
  }

  getSaveCopyNumericStatus() {
    if (this.state === ShareCopyStatus.SHARE_COPY_IN_PROGRESS) {
      return 2;
    }
    if (this.state === ShareCopyStatus.SHARE_COPY_DONE) {
      return 3;
    }
    return 1;
  }
  getStateClass() {
    return {
      "saving": this.state === ShareCopyStatus.SHARE_COPY_IN_PROGRESS,
      "saved": this.state === ShareCopyStatus.SHARE_COPY_DONE
    };
  }
}
